import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { GoogleAuth, User } from '@codetrix-studio/capacitor-google-auth';
import { Platform } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { LogService } from 'src/app/services/common/log.service';
import { SubscriberService } from 'src/app/services/app/subscriber.service';
import { SelectModule } from 'primeng/select';

@Component({
    standalone: true,
    selector: 'app-subscriber-signup',
    templateUrl: './subscriber-signup.component.html',
    styleUrls: ['./subscriber-signup.component.css'],
    imports: [FormsModule, ReactiveFormsModule, SelectModule]
})
export class SubscriberSignupComponent implements OnInit, AfterViewInit {
  ErrorMessage: string;
  subscriberformGroup: FormGroup;
  hide = true;
  confirmhide = true;
  isShowErrorMessage = 0;
  isEmailIDExist = 0;
  isPasswordNotMatch = false;

  isOTPSent: boolean = false;
  isOTPValid: boolean | null = null;
  businessTypeOptions = [
    { label: 'General', value: 'General' },
    { label: 'Hotel', value: 'Hotel' }
  ];

  constructor(private subscriberService: SubscriberService,
     private router: Router,
     private logService:LogService,
     public platform: Platform) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    if (!this.platform.is('capacitor')) {
      this.initGoogleSignUpWeb();
    }
  }

  async onGoogleSignUpClick() {
    if (this.platform.is('capacitor')) {
      await this.signUpWithGoogleAndroid();
      return;
    }

    const googleBtn = document.querySelector('#google-signup div[role="button"]') as HTMLElement | null;
    if (googleBtn) {
      googleBtn.click();
      return;
    }

    // @ts-ignore
    if (typeof google !== 'undefined' && google?.accounts?.id?.prompt) {
      // @ts-ignore
      google.accounts.id.prompt();
    }
  }

  initGoogleSignUpWeb() {
    const googleButton = document.getElementById("google-signup");
    if (!googleButton) {
      return;
    }

    // @ts-ignore
    google.accounts.id.initialize({
      client_id: "219534928011-mg5qkftpsbm6lf1jfk2dp158ciu6eq4c.apps.googleusercontent.com",
      callback: this.handleCredentialResponse.bind(this),
      use_fedcm_for_prompt: true,
      auto_select: false,
      cancel_on_tap_outside: true,
    });

    // @ts-ignore
    google.accounts.id.renderButton(
      googleButton,
      {
        theme: "outline",
        size: "large",
        width: 480,
        text: "signup_with",
        shape: "rectangular",
        isSignedIn: false,
        prompt: "select_account",
      }
    );

    // @ts-ignore
    google.accounts.id.prompt((notification: PromptMomentNotification) => { });
  }

  async handleCredentialResponse(response: any) {
    try {
      if (response.credential) {
        const idToken = response.credential;
        const decodedToken = this.decodeIdToken(idToken);

        if (decodedToken) {
          const userId = decodedToken.sub;
          const userName = decodedToken.name;
          const userEmail = decodedToken.email;
          const password = this.generateRandomPassword()

          this.subscriberformGroup = new FormGroup({
            FirstName: new FormControl(userName?.split(' ')[0] || userName, [Validators.required]),
            LastName: new FormControl(userName?.split(' ').slice(1).join(' ') || '', [Validators.required]),
            Name: new FormControl(userName, [Validators.required]),
            EmailID:new FormControl(userEmail,[Validators.required, Validators.email]),
            MobileNumber : new FormControl(""),
            Address: new FormControl(""),
            State: new FormControl(""),
            City:new FormControl(""),
            PinCode:new FormControl(""),
            GstNo:new FormControl(""),
            BusinessType: new FormControl('General'),
            Password: new FormControl(password, [Validators.required]),
            ConfirmPassword: new FormControl(password, [Validators.required]),
            OTP: new FormControl('')
          });

          this.SubscriberSignUp()
        }
      }
    } catch (ex) {
      console.log("Error in handleCredentialResponse : " + ex);
    }
  }

  generateRandomPassword(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let password = '';
    for (let i = 0; i < 5; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters[randomIndex];
    }
    return password;
  }

  decodeIdToken(idToken: string) {
    try {
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      return payload;
    } catch (error) {
      console.error("Error in decodeIdToken : ", error);
      return null;
    }
  }

  async signUpWithGoogleAndroid() {
    if (this.platform.is('capacitor')) {
      try {
        GoogleAuth.initialize({
          clientId: '219534928011-mg5qkftpsbm6lf1jfk2dp158ciu6eq4c.apps.googleusercontent.com',
          scopes: ['profile', 'email'],
          grantOfflineAccess: true
        });
        const googleUser = await GoogleAuth.signIn();
        console.log('Google User:', googleUser);
        if(googleUser) {
          this.handleAndroidResponse(googleUser);
        }
      } catch (err) {
        this.logService.InsertExceptionLog(err,"Subscriber SignUp","signUpWithGoogleAndroid");
        console.error('Error:', err);
        return null;
      }
    }
  }

  async handleAndroidResponse(response: User) {
    try{
      if (response) {
        const userId = response.id;
        const userName = response.name;
        const userEmail = response.email;
        const password = this.generateRandomPassword()

        this.subscriberformGroup = new FormGroup({
          FirstName: new FormControl(userName?.split(' ')[0] || userName, [Validators.required]),
          LastName: new FormControl(userName?.split(' ').slice(1).join(' ') || '', [Validators.required]),
          Name: new FormControl(userName, [Validators.required]),
          EmailID: new FormControl(userEmail, [Validators.required, Validators.email]),
          MobileNumber: new FormControl(""),
          Address: new FormControl(""),
          State: new FormControl(""),
          City: new FormControl(""),
          PinCode: new FormControl(""),
          GstNo: new FormControl(""),
          BusinessType: new FormControl('General'),
          Password: new FormControl(password, [Validators.required]),
          ConfirmPassword: new FormControl(password, [Validators.required]),
          OTP: new FormControl('')
        });

        this.SubscriberSignUp()
      }
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Subscriber SignUp","signInAndroid");
      console.log("Error in handleCredentialResponse : " + ex);
    }
  }

  initForm() {
    try{
      this.resetEmailIDExist();
      this.subscriberformGroup = new FormGroup({
        FirstName: new FormControl("", [Validators.required]),
        LastName: new FormControl("", [Validators.required]),
        Name: new FormControl(""),
        EmailID:new FormControl("",[Validators.required, Validators.email]),
        MobileNumber : new FormControl("",[Validators.required]),
        Address: new FormControl(""),
        State: new FormControl(""),
        City:new FormControl(""),
        PinCode:new FormControl(""),
        GstNo:new FormControl(""),
        BusinessType: new FormControl('General', [Validators.required]),
        Password: new FormControl("", [Validators.required]),
        ConfirmPassword: new FormControl("", [Validators.required]),
        OTP: new FormControl('', [Validators.required])
      });
      this.isPasswordNotMatch = false;
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Subscriber Signup","initForm");
      console.log(ex);
    }
  }

  sendOTP() {
    const mobileNumber = String(this.subscriberformGroup.controls['MobileNumber'].value ?? '').trim();
    if (mobileNumber.length == 10) {
      try {
        let data = {
          contact: mobileNumber
        };

        this.subscriberService.SendOTP(data).subscribe(
          (result) => {

            this.isOTPSent = true;
          },
          (err: Error) => {
            console.log(err.message);
            this.isOTPSent = false;
          });
      } catch (ex) {
        console.log(ex);
        this.isOTPSent = false;
      }
    }
  }

  async confirmOTP() {
    await this.verifyOTP();
  }

  validateOTPOnInput() {
    const otpValue = this.subscriberformGroup.get('OTP').value;
    if (this.isOTPSent && otpValue && otpValue.toString().length === 4) {
      this.verifyOTP();
    }
  }

  async verifyOTP(): Promise<boolean> {
    const mobileNumber = String(this.subscriberformGroup.controls['MobileNumber'].value ?? '').trim();
    const otp = String(this.subscriberformGroup.controls['OTP'].value ?? '').trim();

    if (mobileNumber && otp) {
      try {
        let data = { contact: mobileNumber, otp: otp };

        let result = await firstValueFrom(this.subscriberService.VerifyOTP(data));
        
        this.isOTPValid = result.message !== 'Invalid OTP';
        
        return this.isOTPValid;
      } catch (error) {
        console.log(error);
        this.isOTPValid = false;
        return false;
      }
    }

    this.isOTPValid = false;
    return false;
  }

  async SubscriberSignUp() {
    try {
      this.resetEmailIDExist();
      this.isPasswordNotMatch = false;

      const firstName = (this.subscriberformGroup.value.FirstName || '').trim();
      const lastName = (this.subscriberformGroup.value.LastName || '').trim();
      this.subscriberformGroup.patchValue({
        Name: `${firstName} ${lastName}`.trim()
      });

      if (this.subscriberformGroup.value.Password !== this.subscriberformGroup.value.ConfirmPassword) {
        this.isPasswordNotMatch = true;
        return;
      }

      if(this.subscriberformGroup.valid){
        const isValid = await this.verifyOTP();
        this.isOTPValid = isValid ? null : false;
        
        if (isValid) {
          const { ConfirmPassword, FirstName, LastName, ...signupPayload } = this.subscriberformGroup.value;
          this.subscriberService.InsertSubscriber(signupPayload).subscribe(
            (result) => {
              if (result.isSuccess == 1 && result.subscriberID > 0) {
                this.initForm();
                this.router.navigate(
                  ['subscriber-login'],
                  { queryParams: { subscriberID: result.subscriberID } }
                )
              }
              else if (result.isSuccess == 0 && result.subscriberID == -1) {
                this.isEmailIDExist = 1;
              }
              else {
                console.log(result);
              }
            },
            (err: Error) => {
              console.log(err.message);
            });
        }
      }
      else{
        this.isShowErrorMessage = 1
      }
    } catch (ex) {
      this.logService.InsertExceptionLog(ex,"Subscriber Signup","SubscriberSignUp");
      console.log(ex);
    }
  }

  resetEmailIDExist(){
    try{
      this.isEmailIDExist = 0;
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Subscriber Signup","resetEmailIDExist");
      console.log(ex);
    }
  }

  redirectTo(page){
    this.router.navigate([page]);
  }
}
